import { Box, Typography } from '@mui/material'
import type { DateTime } from 'luxon'

import { MARKET_TIMEZONE } from '@/features/bidding/constants'

import { FONT_SIZE, MONOSPACE_FONT_FAMILY, WHITE_ALPHA } from './styles'

interface CurrentTimeDisplayProps {
  currentTime: DateTime
}

function CurrentTimeDisplay({ currentTime }: Readonly<CurrentTimeDisplayProps>) {
  const zonedTime = currentTime.setZone(MARKET_TIMEZONE)
  const timeString = zonedTime.toFormat('HH:mm')
  const dateString = zonedTime.toFormat('dd MMM')

  return (
    <Box
      aria-label={`Current time: ${dateString} ${timeString}`}
      sx={{
        px: 1.5,
        py: 0.5,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
      }}
    >
      <Typography
        sx={{
          fontSize: FONT_SIZE.SMALL,
          color: WHITE_ALPHA.MEDIUM,
          mb: 0.25,
        }}
      >
        NOW
      </Typography>
      <Typography
        sx={{
          fontSize: FONT_SIZE.MEDIUM,
          fontWeight: 500,
          fontFamily: MONOSPACE_FONT_FAMILY,
          color: WHITE_ALPHA.FULL,
        }}
      >
        {dateString}
      </Typography>
      <Typography
        sx={{
          fontSize: FONT_SIZE.MEDIUM,
          fontWeight: 500,
          fontFamily: MONOSPACE_FONT_FAMILY,
          color: WHITE_ALPHA.FULL,
        }}
      >
        {timeString}
      </Typography>
    </Box>
  )
}

export default CurrentTimeDisplay
